import $ from 'jquery'

const TABS_SELECTOR = '.tabs'

class Tabs {
  constructor(el) {
    this.el = el
    this.items = $('.tabs__filter-link', this.el)
    this.filterSeleted = $('.tabs__filter-selected', this.el)
    this.articlesItems = $('.tabs__article-item', this.el)
    this.init()
  }

  init() {
    this.listen()
    return this
  }

  listen() {
    this.items.each((index, item) => {
      const trigger = $(item)
      trigger.on('click', () => {
        const dataFilter = trigger.attr('data-filter')
        var filterClass = '.' + dataFilter
        trigger
          .parent()
          .siblings()
          .removeClass('active')
        trigger.parent().toggleClass('active')

        if ($(window).width() < 768) {
          trigger.parents('.tabs__filter').removeClass('tabs__filter--active')
          this.filterSeleted.find('.tabs__filter-selected-text').text(trigger.text())
        }

        if (dataFilter == '*') {
          this.articlesItems.show()
        } else if (dataFilter != '') {
          this.articlesItems.hide()
          $(filterClass).show()
        } else {
          this.articlesItems.show()
        }
      })
    })

    this.filterSeleted.each((index, item) => {
      const dropDownTrigger = $(item)
      dropDownTrigger.on('click', () => {
        if ($(window).width() < 768) {
          dropDownTrigger.parent().toggleClass('tabs__filter--active')
        }
      })
    })
  }
}

export default {
  init() {
    $(TABS_SELECTOR).each((index, item) => new Tabs(item))
  },
}
